var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLessonDemand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4688 5.47439V0.703559C11.4688 0.634115 11.5243 0.582031 11.5903 0.582031H14.4722C14.5417 0.582031 14.5938 0.637587 14.5938 0.703559V5.398C14.5938 5.50217 14.4688 5.5612 14.3924 5.49175L13.1597 4.42925C13.1146 4.39106 13.0451 4.39106 13 4.42925L11.6736 5.56814C11.5903 5.63412 11.4688 5.57856 11.4688 5.47439ZM17.7778 0.582031H16.2639V7.54036C16.2639 7.98828 15.9201 8.36675 15.4722 8.39106C15.2431 8.40148 15.0347 8.32161 14.8785 8.18273L14.875 8.17925L14.8715 8.17578L13.2118 6.6862C13.1354 6.61675 13.0208 6.61675 12.9444 6.68273L11.1806 8.19314C11.0347 8.31814 10.8472 8.39453 10.6389 8.39453C10.1771 8.39453 9.80556 8.023 9.80556 7.5612V0.582031H2.22222C0.996528 0.582031 0 1.86328 0 3.43967V17.7244C0 19.3008 0.996528 20.582 2.22222 20.582H17.7778C19.0035 20.582 20 19.3008 20 17.7244V3.43967C20 1.86328 19.0035 0.582031 17.7778 0.582031Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonDemand);
export default __webpack_public_path__ + "static/media/lesson-demand.8eed29246b059515f46f734f48c923af.svg";
export { ForwardRef as ReactComponent };